export const name = 'rnAdmin';
export default function rnAdmin($http, $q, $log, rnHttp) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  const AAA_SERVICE_NAME = 'aaa';
  const ORG_PATH    = 'admin/organizations/';
  const USER_PATH   = 'admin/users/';
  const DEVICE_PATH = 'admin/devices/';

  var service = {
    getOrgs: getOrgs,
    getUsers: getUsers,
    getDevices: getDevices,
    putLocked: putLocked
  };

  return service;

  //////////////////////

  function getOrgs(offset, limit) {
    var config = {'offset': offset, 'limit': limit};

    return doAaaGet(ORG_PATH, config);
  }

  function getUsers(offset, limit) {
    var config = {'offset': offset, 'limit': limit};

    return doAaaGet(USER_PATH, config);
  }

  function getDevices(offset, limit) {
    var config = {'offset': offset, 'limit': limit};

    return doAaaGet(DEVICE_PATH, config);
  }

  function putLocked(href, locked) {

    return doAaaPut(href, locked);
  }

  function doAaaGet(path, params) {
    let config = {
      params: params,
    };

    return rnHttp.get(AAA_SERVICE_NAME, path, config);
  }

  function doAaaPut(path, content) {

    // DJL - Some HAL implementation for REST responses has already begun on the server. However, the
    // link vals are returning absolute URLs. This is necessary until we formally outline (and implement)
    // our approach to JSON/HAL on both the client and server.
    // TODO remove when we no longer have to deal with absolute and relative URLs
    var start = path.indexOf('admin');
    var end = path.length;
    var modifiedPath = path.substring(start, end);
    var deferred = $q.defer();

    return rnHttp.put(AAA_SERVICE_NAME, modifiedPath, content);
  }
}



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/components/admin/admin.service.js